import { useState } from "react";
import styles from "./Input.module.css";
import { ReactComponent as ErrorSignal } from "../../../assets/errorSignal.svg";

type InputType = "text" | "password" | "email" | "number";

interface InputProps {
  type?: InputType;
  required?: boolean;
  disabled?: boolean;
  readOnly?: boolean;
  register?: any;
  onChange?: any;
  inputId: string;
  min?: number;
  max?: number;
  maxLength?: number;
  label?: string;
  pattern?: string;
  value?: string | undefined;
  placeholder?: string | null;
  labelfocus?: string;
  errorText?: string;
  setErrorText?: React.Dispatch<React.SetStateAction<any>> | any;
}
export const Input = ({
  type = "text",
  label,
  value = undefined,
  min = undefined,
  max = undefined,
  maxLength = undefined,
  pattern = undefined,
  register = () => {},
  onChange = () => {},
  inputId,
  placeholder = null,
  required = false,
  disabled = false,
  readOnly = false,
  labelfocus,
  errorText,
  setErrorText = () => {},
}: InputProps) => {
  const [inputFocus, setInputFocus] = useState(false);

  return (
    <div className={styles.customInput}>
      <div className={!errorText ? styles.container : styles.containerError}>
        {label && (
          <label>
            {label}
            {required && <sup>*</sup>}
          </label>
        )}
        {labelfocus && inputFocus && (
          <label>
            {labelfocus} {required && inputFocus && <sup>*</sup>}
          </label>
        )}
        <input
          {...register(inputId, {
            required,
            onBlur: (e: any) => {
              e.target.placeholder = `${placeholder}`;
              !e.target.value?.length && setInputFocus(false);
            },
            onChange: onChange,
          })}
          disabled={disabled}
          type={type}
          className={styles.button}
          value={value}
          readOnly={readOnly}
          min={min}
          max={max}
          maxLength={maxLength}
          pattern={pattern}
          required={required}
          placeholder={placeholder}
          onFocus={(e) => {
            e.target.placeholder = " ";
            setInputFocus(true);
            setErrorText("");
          }}
          autoComplete={false}
        />
      </div>
      {errorText && (
        <p className={styles.errorText}>
          <ErrorSignal />
          {errorText}
        </p>
      )}
    </div>
  );
};
